import i18n from '@plugins/i18n'

import { getTitle } from '../constant/index'

/**
 * @typedef {import('@/type')}
 * @typedef {import('vue-router/types')}
 */
/**
 *
 * @param {VueRouter} router
 * @param {OptionInitializeApp} option
 */
export function initialize(router, option) {
  router.beforeEach((to, from, next) => beforeEach(to, from, next, option))
  router.afterEach((to, from) => afterEach(to, from, option))
}
/**
 *
 * @param {Route} to
 * @param {Route} from
 * @param {OptionInitializeApp} option
 */
function handLoading(to, from, option) {
  const levelLoading = to.matched.reduce((acc, cur) => {
    if (cur.meta && cur.meta.levelLoading) {
      acc = cur.meta.levelLoading
    }
    return acc
  }, 0)
  if (levelLoading > 0) {
    option.loading.setLevel(levelLoading)
  } else {
    const levelTo = to.matched.length
    const levelFrom = from.matched.length
    if (levelTo == levelFrom || Math.abs(levelTo - levelFrom) == 1) {
      option.loading.setLevel(levelTo)
    } else {
      option.loading.setLevel(1)
    }
  }
}
/**
 *
 * @param {Route} to
 * @param {Route} from
 * @param {NavigationGuardNext} next
 * @param {OptionInitializeApp} option
 */
async function beforeEach(to, from, next, option) {
  if (option.profile.getToken()) {
    await option.profile.getInfo()
  }

  const currentToken = option.profile.getToken()
  const meta = to.matched.reduce(option.convertPermission, null)
  const requiresAuth = meta.requiresAuth
  const requiresNoAuth = meta.requiresNoAuth
  handLoading(to, from, option)
  //chua dang nhap
  if (!currentToken) {
    if (requiresAuth) {
      //yeu cau login de vao
      option.profile.logOut()
      next(option.redirect.login(to))
    } else {
      next()
    }
    return
  }
  //da dang nhap
  if (requiresNoAuth) {
    // neu vao trang yeu cau ko dang nhap thi tu chuyen sang home
    next(option.redirect.home)
    return
  } else if (requiresAuth) {
    // kiem tra nguoi dung co quyen vao trang do ko, ko thi chuyen sang trang home
    option.profile.check(meta.permissions).then(
      (valid) => {
        if (valid) {
          next()
        } else {
          next(option.redirect.home)
        }
      },
      (error) => {
        option.profile.logOut().then((res) => {
          next(option.redirect.login(to))
        })
      }
    )
  } else {
    next()
  }
}
/**
 *
 * @param {Route} to
 * @param {Route} from
 * @param {OptionInitializeApp} option
 */
function afterEach(to, from, option) {
  const title = to.matched.reduce((acc, cur) => {
    if (cur.meta) {
      if (cur.meta.title) {
        acc = i18n.t(cur.meta.title)
      } else if (cur.meta.titleText) {
        acc = cur.meta.titleText
      }
    }
    return acc
  }, '')

  if (title) {
    document.title = `${title} - ${getTitle()}`
  } else {
    document.title = getTitle()
  }
  option.loading.reset()
}
